import { useEffect, useState } from "react";
import { sounds } from "../../lib/sounds";

// Draw games: pick the cards to throw away (tap to raise them), then DRAW n — or STAND PAT. Sits above the player's own cards.
export const DrawPrompt = ({ deadline, serverNow, picked, onConfirm, n }) => {
  const [left, setLeft] = useState(null);
  useEffect(() => {
    if (!deadline) return;
    const tick = () => setLeft(Math.max(0, Math.ceil((deadline - serverNow()) / 1000)));
    tick();
    const id = setInterval(tick, 250);
    return () => clearInterval(id);
  }, [deadline, serverNow]);
  const count = picked.length;
  return (
    <div data-testid="draw-prompt" className="absolute left-1/2 -translate-x-1/2 -top-[170px] z-40 w-max flex flex-col items-center gap-1.5 rise">
      <div className="flex items-center gap-2 rounded-full bg-slate-950/90 border border-amber-400/60 px-4 py-1.5 shadow-[0_0_20px_rgba(251,191,36,0.35)]">
        <span className="font-display tracking-wider text-xs text-amber-100">DRAW {n} · TAP THE CARDS TO THROW AWAY</span>
        {left != null && <span data-testid="draw-countdown" className={`font-mono text-xs rounded-full px-2 py-0.5 ${left <= 4 ? "bg-red-700 text-white" : "bg-black/60 text-amber-200"}`}>{left}s</span>}
      </div>
      <button data-testid="draw-confirm" onClick={() => { sounds.click(); onConfirm(picked); }}
        className={`rounded-full px-5 py-1.5 text-xs font-display tracking-[0.2em] btn-lift ${count ? "btn-gold" : "bg-slate-800 border border-amber-200/40 text-amber-100 hover:border-amber-300"}`}>
        {count ? `DRAW ${count}` : "STAND PAT"}
      </button>
    </div>
  );
};
